import {
  BASE_PATH_ANALYTICS,
  BUTTONS_ANALYTICS,
  MODE_ANALYTICS,
  SCREEN_ANALYTICS,
  LINKS_ANALYTICS,
} from '@/constants/analytics'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'

export const eventDispatcherConfig = (isMfp: boolean): EventDispatcherConfig =>
  ({
    config: {
      screenName: SCREEN_ANALYTICS.CLOUD_VALUE_PROP,
      screenPath: BASE_PATH_ANALYTICS.PORTAL_OOBE,
    },
    defaultData: {
      screenMode: isMfp
        ? MODE_ANALYTICS.MULTI_FUNCTION
        : MODE_ANALYTICS.SINGLE_FUNCTION,
    },
  }) as const

export const CloudValuePropPageAnalytics = createAnalyticsManifest(
  eventDispatcherConfig,
  ({ dispatcher }) => ({
    fireContinueButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.CONTINUE,
      })
    },
    fireSkipButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.SKIP,
      })
    },
    fireTermsOfUseLinkClicked: (href: string) => {
      dispatcher.fireHyperLinkClicked({
        controlName: LINKS_ANALYTICS.HP_SMART_TOU,
        controlDetail: href,
      })
    },
  }),
)
